<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Address Confirmation</h3>
</div>
<div class="modal-body" *ngIf="suggestedAddress">
    <p>The address you entered could not be validated.  Did you mean:</p>
    <p>{{suggestedAddress}}</p>
    <b></b>
    <p>The address you entered:</p>
    <p>{{badAddress}}</p>
</div>
<div class="modal-body" *ngIf="!suggestedAddress">
    <p>The address you entered could not be validated. You entered:</p>
    <p>{{badAddress}}</p>
</div>
<div class="modal-footer ">
    <div *ngIf="suggestedAddress" class="modalBtn"><button type="button" class="btn btn-success modalBtn" (click)="useSuggestedAddress()">Use Suggested Address</button></div>
    <div class="modalBtn"><button type="button" class="btn btn-primary modalBtn" (click)="keepBadAddress()">Keep what I entered</button></div>
    <div class="modalBtn"><button type="button" class="btn btn-outline-dark modalBtn" (click)="cancel()">Cancel</button></div>
</div>